import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import SignupModal from './SignupModal';
import './signup-section.scss';
import { setMobileMenuOpen } from '../../../header/actions';
import PropTypes from 'prop-types';

const Signup = ({ buttonLabel, id }) => {
  const [showingModal, setShowingModal] = useState(false);
  const dispatch = useDispatch();
  const initialState = buttonLabel === 'contact' ? 'MESSAGE' : null;
  const modal = showingModal ? (
    <SignupModal
      closeModal={ () => setShowingModal(false) }
      initialState={ initialState } />
  ) : null;
  const catchHandler = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  const handleJoinClicked = () => {
    setShowingModal(!showingModal);
    dispatch(setMobileMenuOpen(false));
  };
  return (
    <div className="signup-section" onClick={ catchHandler }>
      { modal }
      <div className="join-button"
        data-cy={ id || 'join-button' }
        onClick={ handleJoinClicked }>{ buttonLabel || 'join' }</div>
    </div>
  );
};

Signup.propTypes = {
  buttonLabel: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  id: PropTypes.string
};

export default Signup;
